import React, { Component, Fragment } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { AppDispatch } from 'store';
import { CustomDialogButtonContainer, CustomDialogContent } from '../CustomDialog.styled';
import { Button, DialogActions, DialogContentText, Divider, Typography } from '@material-ui/core';
import { Dispatch } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import { dialogClose } from 'store/dialog/dialog.actions';
import { ErrorMessageDetailsDTO } from 'utils/restApplicationClient';
import { formatErrorMessageWithParams } from 'utils/formatErrorMessage';


interface IProps {
    errorMessage: string;
    errorMessagesDetails?: ErrorMessageDetailsDTO[];
}

interface IDispatchProps {
    dialogClose: () => AppDispatch;
  }

type PropType = IDispatchProps & WithTranslation & IProps;

class GenericError extends Component<PropType> {
  private handleClose = (): void => {
    const { dialogClose } = this.props;
    dialogClose();
  };

  render(): JSX.Element {
    const { t, errorMessage, errorMessagesDetails } = this.props;
    const firstDetail = errorMessagesDetails?.[0];
    const resolvedMessage = firstDetail
      ? formatErrorMessageWithParams(firstDetail.errorMessage, firstDetail.params)
      : formatErrorMessageWithParams(errorMessage);

    return (
      <Fragment>
        <CustomDialogContent>
          <DialogContentText>
            <Typography component="span" color="textPrimary" style={{ whiteSpace: 'pre-line' }}>
              {resolvedMessage}
              <br/>
              Please contact support.
            </Typography>
          </DialogContentText>
        </CustomDialogContent>
        <Divider />
        <DialogActions>
          <CustomDialogButtonContainer>
            <Button color="secondary" variant="contained" onClick={this.handleClose}>
              {t('modal.ok')}
            </Button>
          </CustomDialogButtonContainer>
        </DialogActions>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AppDispatch>): IDispatchProps => ({
  dialogClose: (): AppDispatch => dispatch(dialogClose()),
});

export default connect(null, mapDispatchToProps)(withTranslation()(GenericError)); 